
<div class="page-wrapper">

    <app-bees-header></app-bees-header>

    <!-- Sticky Header -->
    <div class="stricky-header stricked-menu main-menu">
        <div class="sticky-header__content"></div>
    </div>

    <!-- Page Header Start -->
    <section class="page-header">
        <div class="page-header__bg"
             style="background-image: url(assets/images/backgrounds/page-header-bg.jpg);">
        </div>

        <div class="container">
            <div class="page-header__inner">

                <div class="page-header__img-1">
                    <img src="assets/images/resources/page-header-img-1.png"
                         alt="Gallery">
                </div>

                <div class="page-header__shape-1 float-bob-y">
                    <img src="assets/images/shapes/page-header-shape-1.png"
                         alt="">
                </div>

                <h3>Gallery</h3>

                <div class="thm-breadcrumb__inner">
                    <ul class="thm-breadcrumb list-unstyled">
                        <li>
                            <a routerLink="/">Home</a>
                        </li>
                        <li>
                            <span class="fas fa-angle-right"></span>
                        </li>
                        <li>Gallery</li>
                    </ul>
                </div>

            </div>
        </div>
    </section>
    <!-- Page Header End -->

    <!-- Gallery Section Start -->
    <section class="team-page gallery-page">
        <div class="container">

            <div class="row">

                <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6"
                     *ngFor="let image of galleryImages">

                    <div class="team-two__single gallery-card">

                        <div class="team-two__img-box">
                            <div class="team-two__img">

                                <a [href]="'assets/images/team/team-2-' + image + '.jpg'"
                                   target="_blank"
                                   rel="noopener"
                                   [attr.aria-label]="'View gallery image ' + image">

                                    <img
                                        [src]="'assets/images/team/team-2-' + image + '.jpg'"
                                        [alt]="'Gallery image ' + image"
                                        loading="lazy">

                                </a>

                            </div>
                        </div>

                    </div>

                </div>

            </div>

        </div>
    </section>
    <!-- Gallery Section End -->

    <app-bees-footer></app-bees-footer>

</div>
